import { IBreadcrumbProps } from "../../../layout/fullLayout/breadcrumb/IBreadcrumbProps";

// Dashboard Breadcrumb Configuration
export const UPSELL_DASHBOARD_BREADCRUMB: IBreadcrumbProps["items"] = [
  {
    to: "/",
    title: "Home",
  },
  {
    to: "/upselling",
    title: "Upselling",
  },
  {
    to: "/upselling/dashboard",
    title: "Dashboard",
  },
];

// Booking period options with week/month labels
export const BOOKING_PERIOD_OPTIONS = [
  { value: 7, label: "1 Week", subLabel: "Booking Left" },
  { value: 14, label: "2 Weeks", subLabel: "Booking Left" },
  { value: 30, label: "1 Month", subLabel: "Booking Left" },
  { value: 60, label: "2 Months", subLabel: "Booking Left" },
  { value: 90, label: "3 Months", subLabel: "Booking Left" },
  { value: 180, label: "6 Months", subLabel: "Booking Left" },
] as const;

export type BookingPeriodOption =
  (typeof BOOKING_PERIOD_OPTIONS)[number]["value"];

// Default booking period
export const DEFAULT_BOOKING_PERIOD: BookingPeriodOption = 7;

// Helper to get label for a booking period value
export const getBookingPeriodLabel = (value: number): string => {
  const option = BOOKING_PERIOD_OPTIONS.find((opt) => opt.value === value);
  return option ? `${option.label} ${option.subLabel}` : `${value} Days Left`;
};

// Default date range for API calls
export const DEFAULT_DATE_RANGE = {
  fromDate: "2000-01-01",
  toDate: new Date().toISOString().split("T")[0],
};

// API pagination defaults
export const API_PAGINATION_DEFAULTS = {
  pageNumber: 1,
  pageSize: 100,
  rowsPerPage: 10,
  status: "ACTIVE",
};
